<style scoped>
.auto_complete {
    margin-bottom: 20px;
}
.search_box {
    max-height: 300px;
    overflow-y: scroll;
    cursor: pointer;
}
.option_title {
    font-weight: bold;
}
.search_item {
    padding: 5px 20px;
}
.search_item:hover {
    background-color: #edf7fe;
}
.no_search {
    text-align: center;
}
>>> .ivu-select-dropdown.ivu-auto-complete {
    max-height: 200px;
}
.label_text {
    margin-right: 20px;
}
</style>
<template>
    <div class="auto_complete">
        <span class="label_text" v-if="label">{{label}}:</span>
        <AutoComplete
            v-model="search"
            @on-search="handleSearch"
            placeholder="请输入..."
            style="width:300px"
            :transfer="false"
            @on-select="searchList"
        >
            <Option v-for="item in searchData" :value="item" :key="item">{{ item }}</Option>
            <!-- <div class="search_box" v-if="searchData.length>0">
            <div
                class="search_item"
                v-for="item in searchData"
                :key="item.id"
                @click="searchList(item)"x
            >{{item}}</div>
            </div>-->
        </AutoComplete>
        <Button type="text" @click="clearSearch">清空</Button>
    </div>

    <!-- icon="md-close-circle" -->
    <!-- @on-click="clearSearch" -->
</template>
<script>
export default {
    data() {
        return {
            search: "",
            searchData: []
        };
    },
    props: ["label", "list"],
    methods: {
        handleSearch(value) {
            let _list = this.list;
            let _searchData = [];
            _list.forEach(item => {
                if (item.seasonName && item.seasonName.indexOf(value) > -1) {
                    if (_searchData.indexOf(item.seasonName) == -1) {
                        _searchData.push(item.seasonName);
                    }
                }
            });
            this.searchData = _searchData;
        },
        clearSearch() {
            this.search = "";
            this.searchData = [];
            this.$emit("setReturnList", []);
        },
        searchList(name) {
            let _list = this.list;
            _list = _list.filter(item => item.seasonName === name);
            this.$emit("setReturnList", _list);
        }
    }
};
</script>
